import * as Location from 'expo-location';

import { sentryLogger } from '@/adapters/logger/sentryLogger';

import { type LocationCoordinates, type LocationProviderAdapter } from './types';

const locationProvider: LocationProviderAdapter = {
  requestPermission: async (): Promise<boolean> => {
    const { status } = await Location.requestForegroundPermissionsAsync();
    return status === 'granted';
  },

  getCurrentPosition: async (): Promise<LocationCoordinates | null> => {
    try {
      const { status } = await Location.getForegroundPermissionsAsync();
      if (status !== 'granted') {
        return null;
      }

      const location = await Location.getCurrentPositionAsync({});
      return {
        latitude: location.coords.latitude,
        longitude: location.coords.longitude,
      };
    } catch (e) {
      sentryLogger.captureException(e as Error);
      return null;
    }
  },

  reverseGeocode: async (coords: LocationCoordinates): Promise<string | null> => {
    try {
      const { status } = await Location.getForegroundPermissionsAsync();
      if (status !== 'granted') {
        return null;
      }

      const [address] = await Location.reverseGeocodeAsync({
        latitude: coords.latitude,
        longitude: coords.longitude,
      });

      if (!address) {
        return null;
      }

      // Format address parts into a single string
      // e.g. "Tokyo, Shibuya City, Dogenzaka 1-2-3"
      const parts = [
        address.region,
        address.city,
        address.street,
        address.name !== address.street ? address.name : null,
      ].filter(Boolean);

      return parts.length > 0 ? parts.join(', ') : null;
    } catch (e) {
      sentryLogger.captureException(e as Error);
      return null;
    }
  },
};

export { locationProvider };
